<template>
  <div class="container">
    <div class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="平台">
            <el-input style="width:200px" v-model="formInline.platformName" placeholder="平台名称" clearable />
          </el-form-item>
          <el-form-item label="启用状态">
            <el-select
                @clear="formInline.platformStatus=''"
                style="width:200px"
                v-model="formInline.platformStatus"
                clearable
                placeholder="请选择平台状态"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="warning" @click="getLoacl" >同步本地缓存</el-button>
        <el-button type="danger" @click="openEidt" >创建平台</el-button>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              label="平台名称"
              min-width="80"
              prop="platformCNName"
          ></el-table-column>
          <el-table-column
              label="平台英文名"
              min-width="100"
              prop="platformUSName"
          ></el-table-column>
          <el-table-column
              label="默认延保年限"
              min-width="100"
              prop="platformDefaultYear"
          ></el-table-column>
          <el-table-column
              label="排序"
              min-width="100"
              prop="order"
          ></el-table-column>
          <el-table-column
              label="状态"
              min-width="100"
              prop="status"
          >
            <template #default="scope">
              <el-switch @change="updateStatus(scope.row)" v-model="scope.row.status" />
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <el-button  link type="primary" size="small" @click="openEidt(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
      <addPlatform ref="addPlatform" @close="close"></addPlatform>
    </div>
  </div>
</template>
<script>
import {ElButton, ElForm, ElFormItem, ElInput, ElPagination,
  ElSwitch, ElTable, ElTableColumn,ElSelect,ElOption} from "element-plus";
import addPlatform from "@/components/addPlatform.vue";
import {getPlatform, updatePlatformStatus} from "@/utils/api";
import {getLocalPlatform} from "@/../public/js/index"
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
export default {
  name: "orderPlatform",
  components: {
    ElForm,ElFormItem,ElButton,ElInput,ElTable,
    ElSwitch,
    ElTableColumn,ElPagination,ElSelect,ElOption,addPlatform
  },
  mixins:[DynamicHeightMixin],
  data(){
    return{
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      formInline:{},
      tableData:[],
      options:[
        {
          value: 1,
          label: '正常',
        },
        {
          value: 0,
          label: '禁用',
        },
      ]
    }
  },
  beforeMount() {
    this.getPlatform()
  },
  methods:{
    onSubmit(){
        this.PageNumber = 1
      this.getPlatform()
    },
    getPlatform(){
      getPlatform({PageNumber:this.currentPage,
        PageSize:this.pageSize,...this.formInline}).then(res => {
        console.log(res)
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(err=>{
        console.log(err)
      })
    },
    openEidt(data){
      this.$refs.addPlatform.open(data)
    },
    close(){
      this.getPlatform()
    },
    updateStatus(data){
      updatePlatformStatus(data).then(res => {
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    },
    getLoacl(){
      getLocalPlatform(true).then(res => {
        this.platformList = res
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getPlatform();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getPlatform();
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
}
</style>